import { toSignal } from '@angular/core/rxjs-interop';
import { ManagedTextApiService } from './../../shared/services/managed-text-api.service';
import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { finalize } from 'rxjs';
import { QuillViewComponent } from 'ngx-quill';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';

@Component({
  selector: 'app-home',
  imports: [QuillViewComponent, MatProgressBarModule, MatButtonModule],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  readonly textCategory = 'Home Details';
  readonly titleIndex = 1;
  readonly descriptionIndex = 0;

  readonly managedTextApiService = inject(ManagedTextApiService);
  readonly router = inject(Router);

  isLoading = signal(true);

  managedTexts = toSignal(
    this.managedTextApiService.getManagedTextByCategory$(this.textCategory).pipe(
      finalize(() => {
        this.isLoading.set(false);
      })
    ),
    { initialValue: [] }
  );
  title = computed(() => (this.managedTexts().length > this.titleIndex ? this.managedTexts()[this.titleIndex]?.description : ''));
  description = computed(() =>
    this.managedTexts().length > this.descriptionIndex ? this.managedTexts()[this.descriptionIndex]?.description : ''
  );

  startAssessment() {
    this.router.navigate(['/assessments/new']);
  }
}
